import React from 'react';
import { Alert, Button } from 'reactstrap';

const RequerimientoExito = ({ folio, onVolver, mensajeVolver = "Volver al Inicio" }) => {
    return (
        <div className="text-center p-4">
            <div className="mb-4">
                <i className="fa fa-check-circle text-success" style={{ fontSize: '5rem' }}></i>
            </div>
            <h3>¡Requerimiento Ingresado Exitosamente!</h3>
            <Alert color="info" className="mt-4">
                <h4 className="alert-heading">Número de Folio / Atención</h4>
                <p className="display-4 font-weight-bold">{folio?.Folio || folio?.folio || folio?.numero || 'Generando...'}</p>
                <hr />
                <p className="mb-0">
                    Guarde este número para realizar el seguimiento de su caso.
                    <br />Puede consultar el estado de su requerimiento en esta sucursal virtual o contactándonos por nuestros canales oficiales.
                </p>
            </Alert>
            <Button color="primary" size="lg" className="mt-4" onClick={onVolver}>{mensajeVolver}</Button>
        </div>
    );
};

export default RequerimientoExito;
